import React, { Fragment, useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { Col, Modal, Row } from "react-bootstrap";
import { classlist, sectioncreate, sectiondetails, sectionlist, sectionstatus, sectionupdate } from "../../../../services/superadmin";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";

export const SectionMaster = () => {
    const [filterProduct, setFilterProduct] = useState([]);
    const [show, setShow] = useState(false);
    const [secid, setId] = useState(0);
    const [clsid, setClass] = useState("");
    const [clist, setCList] = useState([]);
    const [secname, setSecName] = useState("");
    const [status, setStatus] = useState("1");
    const [errorMsg, setErrorMsg] = useState("");

    const sorting = useMemo(() => {
        return ['asc', 'desc',];
      }, []);

    const columnDefs = [
        {
            headerName: "Class",
            field: "class_id",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Section",
            field: "section",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Status",
            field: "is_active",
            resizable: true,
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <label className="custom-switch mb-0">
                            <input
                                type="checkbox"
                                name="custom-switch-checkbox"
                                className="custom-switch-input"
                                checked={params.value === 1 ? true : false}
                                onChange={() => deletesection(params)}
                            />

                            <span className="custom-switch-indicator"></span>
                        </label>
                    </div>
                );
            },
        },
        {
            headerName: "Actions",
            field: "id",
            resizable: true,
            filter: false,
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a onClick={() => viewsection(params.value)} title="Edit Section"
                            className="btn-sm btn-secondary"
                        >
                            <i className="fa fa-edit fa-lg"></i>
                        </a>
                    </div>
                );
            },
        },
    ];

    function viewsection(aid) {
        setShow(true)
        
        sectiondetails(aid).then((response) => {
            if (response.status === true) {
                setId(response.data.id)
                setClass(response.data.class_id)
                setSecName(response.data.section)
                setStatus(response.data.is_active + "")
                dotracking("edit button in section for " + response.data.section + " (" + aid + ") $$ " + trackobj.sectionlistheading)
            }
        })
    }


    function handleshow() {
        setId(0);
        setClass("");
        setSecName("");
        setErrorMsg("");
        setShow(true);
    }
    function handleclose() {
        setShow(false);
        setId(0);
        setClass("");
        setSecName("");
        setErrorMsg("");
    }

    function deletesection(list) {
        if (list.value === 1) {
            Swal.fire({
                text: "Are you sure want to Inactive?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#ac0404",
                cancelButtonColor: "#6259ca",
                confirmButtonText: "Inactive",
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const temp = new FormData();
                    temp.append("id", list.data.id)
                    temp.append("is_active", 0)
                    dotracking("status icon in section list from Active to Inactive for " + list.data.section + " (" + list.data.id + ") $$ " + trackobj.sectionlistheading)
                    sectionstatus(temp).then((response) => {
                        if (response.status === true) {
                            listall();
                            toast.success(response.message)
                        }
                    })
                }
            });
        } else {
            Swal.fire({
                text: "Are you sure want to Active?",
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#008000",
                cancelButtonColor: "#6259ca",
                confirmButtonText: "Active",
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const temp = new FormData();
                    temp.append("id", list.data.id)
                    temp.append("is_active", 1)
                    dotracking("status icon in section list from Inactive to Active for " + list.data.section + " (" + list.data.id + ") $$ " + trackobj.sectionlistheading)
                    sectionstatus(temp).then((response) => {
                        if (response.status === true) {
                            listall();
                            toast.success(response.message)
                        }
                    })
                }
            });
        }
    }
    useEffect(() => {
        listall();
        classlist().then((response) => {
            if (response.status === true) {
                setCList(response.data)
            }
        })
    }, []);

    function Selectstatus(e) {
        setStatus(e.target.value);
    }


    function listall() {
        setFilterProduct([]);
        sectionlist().then((response) => {
            if (response.status === true) {
                setFilterProduct(response.data)
            }
        })
    }

    function submitsection(e) {
        e.preventDefault();
        setErrorMsg("")
        if (secname !== "") {
            if (clsid !== "") {
                if (secid === 0) {
                    const temp = new FormData();
                    temp.append("section", secname)
                    temp.append("is_active", status)
                    dotracking("add button in section list for " + secname + " $$ " + trackobj.sectionlistheading)
                    sectioncreate(temp).then((response) => {
                        if (response.status === true) {
                            handleclose();
                            listall();
                            toast.success(response.message);
                        }
                    })
                } else if (secid !== 0) {
                    const temp = new FormData();
                    temp.append("id", secid)
                    temp.append("section", secname)
                    temp.append("is_active", status)
                    dotracking("update button in section list for " + secname + " (" + secid + ") $$ " + trackobj.sectionlistheading)
                    sectionupdate(temp).then((response) => {
                        if (response.status === true) {
                            handleclose();
                            listall();
                            toast.success(response.message);
                        }
                    })
                }
            } else {
                setErrorMsg("Please Select Class")
            }
        } else {
            setErrorMsg("Please Enter Section Name")
        }
    }

    return (
        <div className="side-app">
            {localStorage.getItem("Subrole") === "1" &&
                <div className="page-header">
                    <div className="breadcrumb">
                        <h4 className="mb-0">Setup</h4>
                    </div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a>Setup</a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Section Lists
                        </li>
                    </ol>
                </div>
            }
            {localStorage.getItem("Subrole") !== "1" &&
                <div className="page-header">
                    <div className="breadcrumb">
                        <h4 className="mb-0">Master</h4>
                    </div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a>Master</a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Section Lists
                        </li>
                    </ol>
                </div>
            }

            <div className="row">
                <div className="col-12">
                    <form className="card mt-0">

                        <div className="card-body">
                            {localStorage.getItem("Subrole") === "1" &&
                                <div className="text-right">
                                    <a className="btn btn-success" onClick={handleshow}>
                                        <i className="fa fa-plus"></i> Add
                                    </a>
                                </div>
                            }
                            <div className="ag-theme-alpine ag-style mt-2">
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    rowData={filterProduct}
                                    pagination="true"
                                    paginationPageSize="10"
                                    sortingOrder={sorting}
                                    suppressExcelExport={true}
                                    suppressDragLeaveHidesColumns={true}
                                    domLayout="autoWidth"
                                    onGridReady={(params) => {
                                        params.api.sizeColumnsToFit();
                                    }}
                                />
                            </div>

                            <Modal show={show} size="lg" onHide={handleclose}>
                                <Modal.Header>
                                    {secid !== 0 &&
                                        <h4> Section Details</h4>
                                    }
                                    {secid === 0 &&
                                        <h4> Add Section</h4>
                                    }
                                </Modal.Header>
                                <Modal.Body>
                                    <Row className="row-sm mx-0">
                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Class{" "}
                                                    <span className="errortext"> *</span>
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <select className="form-control custom-select" value={clsid}
                                                    onChange={(e) => setClass(e.target.value)}>
                                                    <option value="" defaultValue disabled>--- Select Class ---</option>
                                                    {clist.map((data, i) => {
                                                        return (
                                                            <option value={data.id} key={i}>
                                                                {data.class}
                                                            </option>
                                                        );
                                                    })}

                                                </select>
                                            </div>
                                        </Col>

                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Section Name{" "}
                                                    <span className="errortext"> *</span>
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Section Name"
                                                    className="form-control"
                                                    value={secname}
                                                    onChange={(e) => setSecName(e.target.value)}
                                                />
                                            </div>
                                        </Col>


                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Status <span className="errortext"> *</span>
                                                </label>
                                            </div>

                                            <div className="row" onChange={Selectstatus}>
                                                <div className="col-md-6">
                                                    <label className="custom-control custom-radio custom-control-md">
                                                        <input
                                                            type="radio"
                                                            className="reg-chk"
                                                            id="active"
                                                            value="1"
                                                            checked={status === "1"}
                                                        />
                                                        {" "} Active
                                                    </label>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="custom-control custom-radio custom-control-md">
                                                        <input
                                                            type="radio"
                                                            className="reg-chk"
                                                            id="active"
                                                            value="0"
                                                            checked={status === "0"}
                                                        />
                                                        {" "}Inactive
                                                    </label>
                                                </div>
                                            </div>
                                        </Col>
                                        {errorMsg !== "" && (
                                            <span className="errortext">{errorMsg}</span>
                                        )}
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    {secid !== 0 &&
                                        <a
                                            className="btn btn-success" onClick={submitsection}
                                        >
                                            Update
                                        </a>
                                    }
                                    {secid === 0 &&
                                        <a
                                            className="btn btn-success" onClick={submitsection}
                                        >
                                            Add
                                        </a>
                                    }
                                    <a
                                        className="btn btn-secondary"
                                        onClick={handleclose}
                                    >
                                        Cancel
                                    </a>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </form>
                </div>
            </div>
        </div>


    );
};
